import React, { useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";
import { PrivateAxios } from "../../environment/AxiosInstance";
import { UserAuth } from '../auth/Auth';

export default function ChartTargets({ period }) {
  const { MatchPermission } = UserAuth();

  // ================== ALL HOOKS MUST BE AT THE TOP ==================
  const [data, setData] = useState([]);
  const chartRef = useRef();

  useEffect(() => {
    if (MatchPermission(['Sales All', 'View Sales'])) {
      PrivateAxios.get(`sales/reports/targets-vs-achievements?period=${period}`)
        .then((res) => setData(res.data.data || []))
        .catch(() => {});
    }
  }, [period, MatchPermission]);

  useEffect(() => {
    if (!chartRef.current || !data.length) return;
    const ctx = chartRef.current.getContext("2d");
    if (chartRef.current.chartInstance) chartRef.current.chartInstance.destroy();

    chartRef.current.chartInstance = new Chart(ctx, {
      type: "line",
      data: {
        labels: data.map((d) => d.key),
        datasets: [
          {
            label: "Target",
            data: data.map((d) => d.target),
            borderColor: "blue",
            fill: false,
          },
          {
            label: "Achievement",
            data: data.map((d) => d.achievement),
            borderColor: "green",
            fill: false,
          },
        ],
      },
      options: {
        responsive: true,
        plugins: { legend: { position: "bottom" } },
      },
    });
  }, [data]);

  // ================== PERMISSION CHECK AFTER ALL HOOKS ==================
  if (!MatchPermission(['Sales All', 'View Sales'])) {
    return (
      <div className="p-4 text-center">
        <p>You don't have permission to view sales charts.</p>
      </div>
    );
  }

  return (
    <div className="mt-4">
      <h6>Target vs Achievement ({period})</h6>
      <canvas ref={chartRef} height={300}></canvas>
    </div>
  );
}
